import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function SalesGeneratedPage() {
    return (
        <OnboardingBody title='Sales generated' statusText='Engagement report'>
            <p>Leads captured through Nutshell Chat who successfully became customers.</p>
            <p>
                <em>
                    Example: Leads marked as won after sending a quote request through Nutshell
                    Chat.
                </em>
            </p>
        </OnboardingBody>
    );
}
